(function(){
var PRICING = {
  coilover: { label: 'Coil-over / Smooth body', sizes: [
    { label: '2.0" smooth body / coil-over (w/ or w/o reservoir)', price: 213 },
    { label: '2.5" smooth body / coil-over (w/ or w/o reservoir)', price: 253 },
    { label: '3.0" smooth body / coil-over (w/ or w/o reservoir)', price: 300 }
  ]},
  'oe-coilover': { label: 'OE coil-over w/ spring & top plate', sizes: [
    { label: '2.0" / 2.5" OE coil-over w/ spring & top plate', price: 368 },
    { label: '3.0" OE coil-over w/ spring & top plate', price: 355 }
  ]},
  bypass: { label: 'Bypass', sizes: [
    { label: '2.0" bypass', price: 328 },
    { label: '2.5" bypass', price: 373 },
    { label: '3.0" bypass', price: 350 },
    { label: '3.5" bypass', price: 440 },
    { label: '4.0" bypass', price: 450 },
    { label: '4.4" / 4.5" bypass', price: 520 }
  ]},
  'internal-bypass': { label: 'Internal bypass', sizes: [
    { label: '2.5" internal bypass', price: 318 },
    { label: '3.0" internal bypass', price: 290 }
  ]},
  'bump-stop': { label: 'Bump stop', sizes: [
    { label: '2.0" or 2.5" bump stop', price: 155 },
    { label: '2.0" or 2.5" bump stop with IFP', price: 200 },
    { label: 'King 3.0" bump stop', price: 200 }
  ]},
  'valving-only': { label: 'Valving only (no service)', sizes: [
    { label: '2.0" shock - valving only', price: 100 },
    { label: '2.5" shock - valving only', price: 100 },
    { label: '3.0" shock - valving only', price: 100 },
    { label: '3.5" shock - valving only', price: 100 },
    { label: '4.0" shock - valving only', price: 100 },
    { label: '4.4" / 4.5" shock - valving only', price: 100 }
  ]},
  bilstein: { label: 'Bilstein', sizes: [
    { label: '46mm (2.0") - 5160 / 7100 series', price: 190 },
    { label: '60mm (2.5") - 8125 series', price: 195 },
    { label: '60mm (2.5") - 9100 series', price: 230 },
    { label: '6112 series', price: 325 },
    { label: 'OE coil-over / 8112 / 8100 series', price: 355 }
  ]},
  utv: { label: 'UTV shock', sizes: [
    { label: 'UTV shock rebuild', price: 275 },
    { label: 'UTV valving', price: 150 },
    { label: 'SPEED UTV', price: 325 }
  ]},
  raptor: { label: 'Ford Raptor (FOX OE)', sizes: [
    { label: 'Gen 1 / Gen 2 front shocks', price: 300 },
    { label: 'Gen 1 / Gen 2 rear shocks', price: 300 },
    { label: 'FOX factory series front & rear w/ cooler', price: 350 }
  ]},
  uca: { label: 'Upper control arm service', sizes: [
    { label: 'Upper control arm rebuild (+ parts)', price: 75 }
  ]}
};
var ADDONS = [
  { id: 'cooler',   label: 'Shock has a large cooler', price: 25,  perShock: true,  quoteOnly: false },
  { id: 'cerakote', label: 'Interested in Cerakote',   price: 0,   perShock: false, quoteOnly: true  },
  { id: 'anodize',  label: 'Interested in Anodize',    price: 0,   perShock: false, quoteOnly: true  }
];
var lines = [];
var lineCount = 0;
function addLine() {
  if (lines.length >= 8) { alert('Maximum of 8 shock types per request.'); return; }
  lineCount++;
  lines.push({ id: lineCount, qty: 1, type: '', size: -1, addons: {} });
  renderLines();
  calcAll();
}
function removeLine(id) {
  lines = lines.filter(function(l) { return l.id !== id; });
  renderLines();
  calcAll();
}
function setType(id, val) {
  var line = lines.find(function(l) { return l.id === id; });
  if (!line) return;
  line.type = val;
  line.size = -1;
  line.addons = {};
  renderLines();
  calcAll();
}
function setSize(id, val) {
  var line = lines.find(function(l) { return l.id === id; });
  if (!line) return;
  line.size = parseInt(val);
  calcAll();
}
function setQty(id, delta) {
  var line = lines.find(function(l) { return l.id === id; });
  if (!line) return;
  line.qty = Math.max(1, line.qty + delta);
  var el = document.getElementById('dsm-qty-' + id);
  if (el) el.textContent = line.qty;
  calcAll();
}
function toggleAddon(id, addonId, checked) {
  var line = lines.find(function(l) { return l.id === id; });
  if (!line) return;
  line.addons[addonId] = checked;
  var wrap = document.getElementById('dsm-wrap-' + id + '-' + addonId);
  if (wrap) {
    if (checked) { wrap.classList.add('dsm-selected'); }
    else { wrap.classList.remove('dsm-selected'); }
  }
  calcAll();
}
function getLinePrice(line) {
  if (!line.type || line.size < 0) return 0;
  var shock = PRICING[line.type].sizes[line.size];
  if (!shock) return 0;
  var total = shock.price * line.qty;
  ADDONS.forEach(function(a) {
    if (!a.quoteOnly && line.addons[a.id]) {
      total += a.perShock ? a.price * line.qty : a.price;
    }
  });
  return total;
}
function renderLines() {
  var container = document.getElementById('dsm-shock-lines');
  if (!container) return;
  container.innerHTML = '';
  lines.forEach(function(line, idx) {
    var isValvingOnly = line.type === 'valving-only';
    var typeOpts = '<option value="">Select type...</option>';
    Object.keys(PRICING).forEach(function(k) {
      typeOpts += '<option value="' + k + '"' + (line.type === k ? ' selected' : '') + '>' + PRICING[k].label + '</option>';
    });
    var sizeOpts = '<option value="-1">Select size...</option>';
    if (line.type && PRICING[line.type]) {
      PRICING[line.type].sizes.forEach(function(s, i) {
        sizeOpts += '<option value="' + i + '"' + (line.size === i ? ' selected' : '') + '>' + s.label + ' - $' + s.price + '</option>';
      });
    }
    var addonHtml = '';
    if (!isValvingOnly) {
      addonHtml = '<div><label class="slabel mb8">Add-ons for this set</label><div class="addon-grid">';
      ADDONS.forEach(function(a) {
        var checked = line.addons[a.id] ? ' checked' : '';
        var sel = line.addons[a.id] ? ' dsm-selected' : '';
        var priceLabel = a.quoteOnly
          ? '<span class="quote-badge">Quote on request</span>'
          : (a.perShock ? '(+$' + a.price + '/shock)' : '(+$' + a.price + ' min)');
        addonHtml += '<label class="addon-item' + sel + '" id="dsm-wrap-' + line.id + '-' + a.id + '">'
          + '<input type="checkbox"' + checked + ' id="dsm-cb-' + line.id + '-' + a.id + '">'
          + '<span>' + a.label + ' ' + priceLabel + '</span>'
          + '</label>';
      });
      addonHtml += '</div></div>';
    }
    var lp = getLinePrice(line);
    var priceTxt = lp > 0 ? 'Line estimate: $' + lp.toLocaleString() : '';
    var removeBtn = lines.length > 1
      ? '<button class="remove-btn" id="dsm-remove-' + line.id + '" type="button">Remove</button>'
      : '';
    var valvingBadge = (!isValvingOnly && line.type)
      ? '<span class="incl-badge">&#10003; Valving Included</span><br>'
      : '';
    var cardHtml = '<div class="shock-card" id="dsm-line-' + line.id + '">'
      + '<div class="shock-card-header">'
        + '<span class="shock-num">Shock Set ' + (idx + 1) + '</span>'
        + removeBtn
      + '</div>'
      + '<div class="row2">'
        + '<div><label class="slabel">Type</label>'
          + '<select id="dsm-type-' + line.id + '">'
            + typeOpts
          + '</select>'
        + '</div>'
        + '<div><label class="slabel">Size</label>'
          + '<select id="dsm-size-' + line.id + '"' + (!line.type ? ' disabled' : '') + '>'
            + sizeOpts
          + '</select>'
        + '</div>'
      + '</div>'
      + '<div><label class="slabel">Quantity</label>'
        + '<div class="qty-row">'
          + '<button class="qty-btn" id="dsm-qminus-' + line.id + '" type="button">&#8722;</button>'
          + '<span class="qty-val" id="dsm-qty-' + line.id + '">' + line.qty + '</span>'
          + '<button class="qty-btn" id="dsm-qplus-' + line.id + '" type="button">&#43;</button>'
          + '<span style="font-size:12px;color:#666;margin-left:4px;">shock(s)</span>'
        + '</div>'
      + '</div>'
      + valvingBadge
      + addonHtml
      + '<div class="line-price" id="dsm-lp-' + line.id + '">' + priceTxt + '</div>'
    + '</div>';
    var wrapper = document.createElement('div');
    wrapper.innerHTML = cardHtml;
    container.appendChild(wrapper.firstChild);
    var lineId = line.id;
    var typeEl = document.getElementById('dsm-type-' + lineId);
    if (typeEl) typeEl.addEventListener('change', function() { setType(lineId, this.value); });
    var sizeEl = document.getElementById('dsm-size-' + lineId);
    if (sizeEl) sizeEl.addEventListener('change', function() { setSize(lineId, this.value); });
    var qminusEl = document.getElementById('dsm-qminus-' + lineId);
    if (qminusEl) qminusEl.addEventListener('click', function() { setQty(lineId, -1); });
    var qplusEl = document.getElementById('dsm-qplus-' + lineId);
    if (qplusEl) qplusEl.addEventListener('click', function() { setQty(lineId, 1); });
    var removeEl = document.getElementById('dsm-remove-' + lineId);
    if (removeEl) removeEl.addEventListener('click', function() { removeLine(lineId); });
    ADDONS.forEach(function(a) {
      var cbEl = document.getElementById('dsm-cb-' + lineId + '-' + a.id);
      if (cbEl) {
        cbEl.addEventListener('change', function() { toggleAddon(lineId, a.id, this.checked); });
      }
    });
  });
  var addBtn = document.getElementById('dsm-add-btn');
  if (addBtn) addBtn.style.display = lines.length >= 8 ? 'none' : 'block';
}
function calcAll() {
  var grandTotal = 0;
  var summaryRows = '';
  var hasAny = false;
  lines.forEach(function(line, idx) {
    var lp = getLinePrice(line);
    var lpEl = document.getElementById('dsm-lp-' + line.id);
    if (lpEl) lpEl.textContent = lp > 0 ? 'Line estimate: $' + lp.toLocaleString() : '';
    if (lp > 0) {
      hasAny = true;
      grandTotal += lp;
      var shock = PRICING[line.type].sizes[line.size];
      var isValvingOnly = line.type === 'valving-only';
      summaryRows += '<div class="price-row">'
        + '<span>Set ' + (idx + 1) + ': ' + shock.label + ' x ' + line.qty
        + (!isValvingOnly ? ' <span style="font-size:10px;color:#946B3A;">(valving incl.)</span>' : '')
        + '</span>'
        + '<span style="white-space:nowrap;">$' + (shock.price * line.qty).toLocaleString() + '</span>'
        + '</div>';
      ADDONS.forEach(function(a) {
        if (line.addons[a.id]) {
          if (a.quoteOnly) {
            summaryRows += '<div class="price-row" style="padding-left:14px;color:#888;">'
              + '<span>' + a.label + '</span>'
              + '<span style="color:#946B3A;white-space:nowrap;">Quote on request</span>'
              + '</div>';
          } else {
            var ap = a.perShock ? a.price * line.qty : a.price;
            summaryRows += '<div class="price-row" style="padding-left:14px;color:#888;">'
              + '<span>' + a.label + '</span>'
              + '<span style="white-space:nowrap;">$' + ap.toLocaleString() + '</span>'
              + '</div>';
          }
        }
      });
    }
  });
  if (hasAny) {
    summaryRows += '<div class="price-row" style="margin-top:10px;">'
      + '<span style="font-weight:700;text-transform:uppercase;letter-spacing:.05em;">Estimated Total</span>'
      + '<span class="price-total">$' + grandTotal.toLocaleString() + '</span>'
      + '</div>';
    document.getElementById('dsm-summary-rows').innerHTML = summaryRows;
    document.getElementById('dsm-summary').classList.remove('dsm-hidden');
  } else {
    document.getElementById('dsm-summary').classList.add('dsm-hidden');
  }
}
function submitForm() {
  var name = document.getElementById('dsm-name').value.trim();
  var email = document.getElementById('dsm-email').value.trim();
  if (!name || !email) { alert('Please enter your name and email before submitting.'); return; }
  if (lines.length === 0) { alert('Please add at least one shock type.'); return; }
  var body = 'Shock Service Request\n\n'
    + 'Customer: ' + name + '\n'
    + 'Email: ' + email + '\n'
    + 'Phone: ' + (document.getElementById('dsm-phone').value || 'Not provided') + '\n'
    + 'Vehicle: ' + (document.getElementById('dsm-vehicle').value || 'Not provided') + '\n'
    + 'Shock brand/model: ' + (document.getElementById('dsm-brand').value || 'Not provided') + '\n'
    + '\nShock Details:\n';
  lines.forEach(function(line, idx) {
    var typeName = line.type ? PRICING[line.type].label : 'Not selected';
    var sizeName = (line.type && line.size >= 0) ? PRICING[line.type].sizes[line.size].label : 'Not selected';
    var isValvingOnly = line.type === 'valving-only';
    var addonList = ADDONS.filter(function(a) { return line.addons[a.id]; })
      .map(function(a) { return a.quoteOnly ? a.label + ' (quote requested)' : a.label; }).join(', ') || 'None';
    var lp = getLinePrice(line);
    body += '\nSet ' + (idx + 1) + ':\n'
      + '  Type: ' + typeName + '\n'
      + '  Size: ' + sizeName + '\n'
      + '  Quantity: ' + line.qty + '\n'
      + '  Valving: ' + (isValvingOnly ? 'Valving only ($100 flat)' : 'Included in service') + '\n'
      + '  Add-ons: ' + addonList + '\n'
      + '  Line estimate: $' + lp.toLocaleString() + '\n';
  });
  var grandTotal = lines.reduce(function(s, l) { return s + getLinePrice(l); }, 0);
  body += '\nTotal estimate: $' + grandTotal.toLocaleString()
    + '\n\nNotes: ' + (document.getElementById('dsm-notes').value || 'None');
  window.location.href = 'mailto:sales@downsouth-motorsports.com'
    + '?subject=' + encodeURIComponent('Shock Service Request - ' + name)
    + '&body=' + encodeURIComponent(body);
  document.getElementById('dsm-form-wrap').classList.add('dsm-hidden');
  document.getElementById('dsm-success-wrap').classList.remove('dsm-hidden');
}
document.addEventListener('DOMContentLoaded', function() {
  var addBtn = document.getElementById('dsm-add-btn');
  if (addBtn) addBtn.addEventListener('click', addLine);
  var submitBtn = document.getElementById('dsm-submit-btn');
  if (submitBtn) submitBtn.addEventListener('click', submitForm);
  addLine();
});
if (document.readyState === 'complete' || document.readyState === 'interactive') {
  var addBtn = document.getElementById('dsm-add-btn');
  if (addBtn && !addBtn._dsm_bound) {
    addBtn._dsm_bound = true;
    addBtn.addEventListener('click', addLine);
  }
  var submitBtn = document.getElementById('dsm-submit-btn');
  if (submitBtn && !submitBtn._dsm_bound) {
    submitBtn._dsm_bound = true;
    submitBtn.addEventListener('click', submitForm);
  }
  if (lines.length === 0) addLine();
}
})();